import React, { useEffect, useState } from 'react';
import { ATMForm, ATMHeader, ATMGrid } from 'shared-it-appmod-ui';
import { FileCategory } from 'src/constants';
import Lang from 'src/libraries/language';
import { IRequestFormMethods } from 'src/models/request.model';
import FormUpload from 'src/components/organisms/form-upload/form-upload.component';
import LabelRequired from 'src/components/atoms/label-required/label-required.component';

type IProps = IRequestFormMethods & {
  category: string;
};

const FlightRequestFlightArea: React.FC<IProps> = ({
  category,
  control,
  errors,
}) => {
  const [fileErr, setFileErr] = useState(false);
  if (fileErr && category in errors && !errors[category].flightAreaFiles) {
    setFileErr(false);
  }

  useEffect(() => {
    if (category in errors && errors[category].flightAreaFiles) {
      setFileErr(true);
    }
  }, [errors]);
  return (
    <>
      <ATMHeader size="small" className="text-underline">
        {Lang.LBL_FLIGHT_AREA}
      </ATMHeader>
      <ATMGrid>
        <ATMGrid.Column width={10}>
          <ATMForm.Field>
            <LabelRequired>{Lang.NTE_ATTACH_FILE_FLIGHT_AREA_1}</LabelRequired>
            <label>{Lang.NTE_ATTACH_FILE_FLIGHT_AREA_2}</label>
            <span id="flightAreaFiles">
              {fileErr ? (
                <div
                  className="ui pointing below prompt label"
                  role="alert"
                  aria-atomic="true"
                >
                  Upload a file
                </div>
              ) : null}
            </span>
            <FormUpload
              control={control}
              errors={errors}
              name={`${category}.flightAreaFiles`}
              allowedTypes={[FileCategory.FlightArea]}
              fileRestriction={['pdf', 'jpg', 'png']}
              min={1}
              inline
            />
          </ATMForm.Field>
        </ATMGrid.Column>
      </ATMGrid>
    </>
  );
};

export default FlightRequestFlightArea;
